<script setup>
import {onBeforeMount, onMounted, reactive, ref, nextTick} from 'vue'
import BoxUpload from "@/components/YTBoxUpload/index.vue"
import {addOrUpdateStore, editOrUpdateStore, storeDetail} from "@/api/post/post.js";
import moment from "moment";
import router from "@/router/index.js";
import {getRoute} from "@/hooks/getRoute.js";
import YTAddress from "@/components/YTAddress/index.vue";

const loading = ref(false)
/*获取路由信息，带参则为修改*/
const {route} = getRoute()
// 带参则为修改
const isEdit = ref(false)
onBeforeMount(() => {
  isEdit.value = Boolean(route.query.storeId)
  if (isEdit.value) {
    getDetail(route.query.storeId)
  } else {
    addOperatingTime()
  }
})
/*获取商店信息*/
const getDetail = async (storeId) => {
  loading.value = true
  try {
    const res = await storeDetail(storeId)
    if (!res) throw new Error("null")
    Object.assign(ruleForm, res);
    ruleForm.operatingHours.map(item => {
      item.operatingTime = []
      console.log("moment().format(\"YYYY-MM-DD\") + ' ' + item.operatingStart", moment().format("YYYY-MM-DD") + ' ' + item.operatingStart)
      item.operatingTime[0] = moment(moment().format("YYYY-MM-DD") + ' ' + item.operatingStart).format()
      item.operatingTime[1] = moment(moment().format("YYYY-MM-DD") + ' ' + item.operatingEnd).format()
    })
    // handleSelfOperatedChange(res.isSelfOperated)
    console.log("ruleForm", ruleForm)
    // 特殊处理地址反显
    let temp = []
    temp.push(ruleForm.storeAddress.provinceCode)
    temp.push(ruleForm.storeAddress.cityCode)
    temp.push(ruleForm.storeAddress.districtCode)
    ruleForm.showAddressCode = temp.join("/")
    handleReview(res.photoList)
    handleEnvReview(res.environmentPhotoList)
    loading.value = false
  } catch (e) {
    console.log(e)
    if (e.message === "null") {
      ElMessage({
        type: "warning",
        message: "暂无此门店数据",
        duration: 3000,
        onClose: () => {
          router.push("/listPost")
        }
      })
    }
  }
}
/*表单信息*/
// 表单大小
const formSize = ref('large')
// 表单锚点
const ruleFormRef = ref()
// 上传组件锚点
const boxUploadRef = ref()
// 店铺环境上传组件锚点
const boxUploadEnvRef = ref()
// 表单信息
const ruleForm = reactive({
  name: null,
  nameEn: "Coming Soon ...",
  storeType: null,
  phone: null,
  storeAddress: {
    provinceCode: null,
    cityCode: null,
    districtCode: null,
    addressDetail: null,
    addressDetailEn: "Coming Soon ...",
  },
  showAddressCode: null,
  photoList: [],
  environmentPhotoList: [],
  operatingStart: null,
  operatingEnd: null,
  description: null,
  descriptionEn: "Coming Soon ...",
  operatingHours: [],
  isSelfOperated: true,
  nonSelfOperatedLink: null
})
// 校验表单 - 照片列表
const checkPhotoList = (rule, value, callback) => {
  if(boxUploadRef.value.fileList.length <= 0) return callback(new Error('请上传至少一张门店照片'))
  callback()
}
// 校验表单 - 营业时间
const checkOperatingHours = (rule, value, callback) => {
  console.log("ruleForm.operatingHours.length < 0", ruleForm.operatingHours.length <= 0)
  if (ruleForm.operatingHours.length <= 0) {
    return callback(new Error("请添加营业时间"))
  } else {
    console.log("校验规则：", ruleForm.operatingHours)
    ruleForm.operatingHours.map(item => {
      console.log("开始星期", item.weekdayOpen)
      console.log("开始星期布尔值", Boolean(!item.weekdayOpen))
      if (!item.weekdayOpen) {
        return callback(new Error("有开始星期未选择"))
      }
      if (!item.weekdayClose) {
        return callback(new Error("有结束星期未选择"))
      }
      if (!item.operatingTime[0] || !item.operatingTime[1]) {
        return callback(new Error("有营业时间未选择"))
      }
    })
  }
  return callback()
}
// 门店名称校验规则
const checkName = (rule, value, callback) => {
  if (!ruleForm.name) {
    return callback(new Error("门店名称（中文）不能为空！"))
  }
  if (!ruleForm.nameEn) {
    return callback(new Error("门店名称（English）不能为空！"))
  }
  return callback()
}
// 详细地址校验规则
const checkAddressDetail = (rule, value, callback) => {
  if (!ruleForm.storeAddress.addressDetail) {
    return callback(new Error("详细地址（中文）不能为空！"))
  }
  if (!ruleForm.storeAddress.addressDetailEn) {
    return callback(new Error("详细地址（English）不能为空！"))
  }
  return callback()
}
// 商品推荐校验规则
const checkDescription = (rule, value, callback) => {
  if (ruleForm.description && !ruleForm.descriptionEn) {
    return callback(new Error("商品推荐（English）不能为空！"))
  }
  return callback()
}
// 所属区域校验规则
const checkShowAddress = (rule, value, callback) => {
  if (!ruleForm.storeAddress.provinceCode || !ruleForm.storeAddress.cityCode || !ruleForm.storeAddress.districtCode) {
    return callback(new Error("请选择所属区域"))
  }
  return callback()
}
// 表单校验规则
const rules = reactive({
  name: [
    {required: true, validator: checkName, trigger: 'blur'},
  ],
  storeType: [
    {required: true, message: "请选择类型", trigger: "change"}
  ],
  phone: [
    {required: true, message: '联系电话不能为空', trigger: 'blur'}
  ],
  storeAddress: {
    addressDetail: [
      {required: true, validator: checkAddressDetail, trigger: 'blur'}
    ],
  },
  showAddressCode: [
    { required: true, validator: checkShowAddress, trigger: 'blur' }
  ],
  photoList: [
    {required: true, validator: checkPhotoList, trigger: 'blur'}
  ],
  operatingHours: [
    {required: true, validator: checkOperatingHours, trigger: 'blur'}
  ],
  description: [
    {validator: checkDescription, trigger: 'blur'}
  ]
})
// 表单校验
const submit = async () => {
  loading.value = true
  await ruleFormRef.value.validate(async (valid, fields) => {
    if (valid) {
      await createStore()
    } else {
      ElMessage.error("请根据提示修改表单信息")
      loading.value = false
    }
  })
}
// 门店类型枚举
const storeTypeEnum = [
  {
    label: "驿站",
    value: "STATION"
  },
  // {
  //   label: "网球场馆",
  //   value: "TENNIS_VENUE"
  // },
  {
    label: "泵道场地",
    value: "PUMP_TRACK_VENUE"
  },
  {
    label: "山地场地",
    value: "MOUNTAIN_BIKE_VENUE"
  },
  {
    label: "小轮车场地",
    value: "BMX_VENUE"
  },
  {
    label: "单车4S店",
    value: "BIKE_STORE"
  }
]
// 创建门店
const createStore = async () => {
  console.log("ruleForm:", ruleForm)
  // 处理营业时间
  ruleForm.operatingHours.map(item => {
    item.operatingStart = moment(item.operatingTime[0]).format("HH:mm:ss")
    item.operatingEnd = moment(item.operatingTime[1]).format("HH:mm:ss")
    console.log("开始时间搜索结果", startDataOptions.value.find(i => i.value === item.weekdayOpen))
    if (typeof item.weekdayOpen === "number" || typeof item.weekdayClose === "number") {
      item.weekdayOpen = startDataOptions.value.find(i => i.value === item.weekdayOpen).label
      item.weekdayClose = startDataOptions.value.find(i => i.value === item.weekdayClose).label
    }
  })
  try {
    if (isEdit.value) {
      await editOrUpdateStore(ruleForm)
    } else {
      await addOrUpdateStore(ruleForm)
    }
    ElMessage({
      type: "success",
      message: isEdit.value ? "修改成功" : "创建成功",
      duration: 3000
    })
    loading.value = false
    router.push('/listPost')
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 清空表单信息
const resetForm = () => {
  router.back()
}

// 处理图片上传成功
const handlePicSuccess = (url) => {
  ruleForm.photoList = []
  ruleForm.photoList = url
  loading.value = false
}
// 处理店铺环境照片上传成功
const handlePicEnvironmentPhotoListSuccess = (url) => {
  ruleForm.environmentPhotoList = []
  ruleForm.environmentPhotoList = url
  loading.value = false
}
// 处理图片反显
const handleReview = (reviewList) => {
  console.log("father handleReview", reviewList)
  boxUploadRef.value.handleReview(reviewList)
}
// 处理图片反显
const handleEnvReview = (reviewList) => {
  console.log("father handleEnvReview", reviewList)
  nextTick(() => {
    boxUploadEnvRef.value.handleReview(reviewList)
  })
}
// 处理删除图片
const handlePicRemove = (url) => {
  ruleForm.photoList = url
}
// 处理删除店铺环境图片图片
const handlePicEnvironmentPhotoListRemove = (url) => {
  ruleForm.environmentPhotoList = url
}

// 处理选择所属区域
const handleSelectAddress = (data) => {
  console.log("data:", data)
  const res = data.value.split("/")
  ruleForm.showAddressCode = data.value.split("/")
  ruleForm.storeAddress.provinceCode = res[0]
  ruleForm.storeAddress.cityCode = res[1]
  ruleForm.storeAddress.districtCode = res.length > 2 ? res[2] : null
  ruleFormRef.value.validateField("showAddress")
}

// 开始日期星期数组
const startDataOptions = ref([
  {
    label: "周一",
    value: "MONDAY",
  },
  {
    label: "周二",
    value: "TUESDAY",
  },
  {
    label: "周三",
    value: "WEDNESDAY",
  },
  {
    label: "周四",
    value: "THURSDAY",
  },
  {
    label: "周五",
    value: "FRIDAY",
  },
  {
    label: "周六",
    value: "SATURDAY",
  },
  {
    label: "周日",
    value: "SUNDAY",
  }
])

// 添加营业时间
const addOperatingTime = () => {
  ruleForm.operatingHours.push({
    weekdayOpen: null,
    weekdayClose: null,
    operatingStart: null,
    operatingEnd: null,
    operatingTime: []
  })
}
// 删除已填写的营业时间
const removeOperatingTime = (index) => {
  console.log("index", index)
  ruleForm.operatingHours.splice(index, 1)
  ruleFormRef.value.validateField("operatingHours")
}
// 判断营业结束时间选择范围
const handleWeekdayClose = (item, index) => {
  try {
    const findIndex = startDataOptions.value.findIndex(i => i.value === item.weekdayOpen)
    return index < findIndex
  } catch (e) {
    console.log(e)
    return false
  }
}
// 处理更改营业开始时间清空营业关闭时间
const handleClearClose = (index) => {
  ruleForm.operatingHours[index].weekdayClose = null
}

// 处理合作门店勾选
/*管理员不勾选，表示这个门店是骑么自营门店
管理员勾选，但是没有填写“合作门店小程序链接”，表示这个门店是合作门店，但是使用biking up小程序点餐；
管理员勾选，并填写“合作门店小程序链接”，表示这个门店是合作门店，并且跳转到他们自有小程序进行点餐*/
const handleSelfOperatedChange = (e) => {
  console.log("run in handleSelfOperatedChange")
  ruleForm.isSelfOperated = !e
}

/*中英文切换输入框相关Tab*/
// 门店名称tab
const nameTab = ref("zh")
// 详细地址tab
const addressDetailTab = ref("zh")
// 商家推荐tab
const descriptionTab = ref("zh")
</script>

<template>
  <div class="container_box">
    <v-container class="flex_center">
      <el-form
          ref="ruleFormRef"
          style="max-width: 100%"
          :model="ruleForm"
          :rules="rules"
          label-width="auto"
          class="demo-ruleForm"
          :size="formSize"
          status-icon
          v-loading="loading"
      >
        <el-form-item label="门店名称：" prop="name">
          <el-tabs
              v-model="nameTab"
              type="card"
              class="demo-tabs"
          >
            <el-tab-pane label="中文" name="zh">
              <el-input style="width: 498px;" show-word-limit v-model="ruleForm.name" maxlength="20" placeholder="门店名称最长20个字" />
            </el-tab-pane>
            <el-tab-pane label="English" name="en">
              <el-input style="width: 498px;" show-word-limit v-model="ruleForm.nameEn" maxlength="60" placeholder="The name of a store should be up to 60 characters long" />
            </el-tab-pane>
          </el-tabs>
        </el-form-item>
        <el-form-item label="类型：" prop="storeType" style="width: 250px;">
          <el-select v-model="ruleForm.storeType" placeholder="请选择" :disabled="isEdit">
            <el-option
                v-for="item in storeTypeEnum"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="联系电话：" prop="phone">
          <el-input style="width: 498px;" show-word-limit v-model="ruleForm.phone" maxlength="12" placeholder="请输入电话号码，座机/手机均可" />
        </el-form-item>
        <el-form-item label="所属区域：" prop="showAddressCode">
          <div class="w-100">
            <YTAddress style="width: 498px;" :addressCode="ruleForm.showAddressCode" :is-return-str="true" @select="handleSelectAddress"></YTAddress>
          </div>
        </el-form-item>
        <el-form-item label="详细地址：" prop="storeAddress.addressDetail">
          <el-tabs
              v-model="addressDetailTab"
              type="card"
              class="demo-tabs"
          >
            <el-tab-pane label="中文" name="zh">
              <el-input style="min-width: 498px;" v-model="ruleForm.storeAddress.addressDetail" placeholder="请填写详细地址（勿重复填写省市区）" />
            </el-tab-pane>
            <el-tab-pane label="English" name="en">
              <el-input style="min-width: 498px;" v-model="ruleForm.storeAddress.addressDetailEn" placeholder="Please fill in the detailed address (do not repeatedly fill in the province, city and district)" />
            </el-tab-pane>
          </el-tabs>
        </el-form-item>
        <el-form-item label="门店照片：" prop="photoList">
          <BoxUpload ref="boxUploadRef" :ali-oss-path="'STORE_IMG_PATH'" @progress="loading = true" @success="handlePicSuccess" @remove="handlePicRemove" :limit="20"/>
        </el-form-item>
        <el-form-item label="店铺环境照片：" prop="environmentPhotoList" v-if="ruleForm.storeType === 'BIKE_STORE'">
          <BoxUpload ref="boxUploadEnvRef" :ali-oss-path="'STORE_ENVIRONMENT_PHOTO_LIST'" @progress="loading = true" @success="handlePicEnvironmentPhotoListSuccess" @remove="handlePicEnvironmentPhotoListRemove" :limit="5"/>
        </el-form-item>
        <el-form-item label="营业时间：" prop="operatingHours">
          <div>
            <div class="flex_center mg_b_1" v-for="(item, index) in ruleForm.operatingHours" :key="`operatingHours${index}`">
              <div class="flex">
                <el-select
                    v-model="item.weekdayOpen"
                    placeholder="开始星期"
                    size="large"
                    style="width: 120px"
                    class="mg_r_1"
                    @change="handleClearClose(index)"
                >
                  <el-option
                      v-for="opt in startDataOptions"
                      :key="opt.value"
                      :label="opt.label"
                      :value="opt.value"
                  />
                </el-select>
                <span class="mg_r_1">
                至
              </span>
                <el-select
                    v-model="item.weekdayClose"
                    placeholder="结束星期"
                    size="large"
                    style="width: 120px"
                    class="mg_r_1"
                    :disabled="item.weekdayOpen === null"
                >
                  <el-option
                      v-for="(opt, optIndex) in startDataOptions"
                      :key="opt.value"
                      :label="opt.label"
                      :value="opt.value"
                      :disabled="handleWeekdayClose(item, optIndex)"
                  />
                </el-select>
              </div>
              <div class="flex mg_r_1">
                <el-time-picker format="HH:mm" class="mg_r_1" style="max-width: 150px" v-model="item.operatingTime[0]" placeholder="营业开始时间" />
                <div class="mg_r_1">至</div>
                <el-time-picker format="HH:mm" style="max-width: 150px" v-model="item.operatingTime[1]" placeholder="营业结束时间" />
              </div>
              <el-tooltip
                  class="box-item"
                  effect="dark"
                  content="删除"
                  placement="right">
                <v-icon class="cursor-pointer" color="error" icon="mdi-close" @click="removeOperatingTime(index)"></v-icon>
              </el-tooltip>
            </div>
            <div class="flex_left">
              <v-icon class="cursor-pointer mg_r_1" icon="mdi-plus-circle-outline" color="success" size="32" @click="addOperatingTime"></v-icon>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="合作门店：" prop="isSelfOperated">
          <div class="flex_left w-100">
            <el-checkbox v-if="!loading" class="mg_r_1" :checked="!ruleForm.isSelfOperated" @change="handleSelfOperatedChange" />
            <el-input v-if="!ruleForm.isSelfOperated" v-model="ruleForm.nonSelfOperatedLink" placeholder="请输入合作门店的小程序链接"></el-input>
          </div>
        </el-form-item>
        <el-form-item label="商家推荐：" prop="description">
          <el-tabs
              v-model="descriptionTab"
              type="card"
              class="demo-tabs"
          >
            <el-tab-pane label="中文" name="zh">
              <el-input
                  v-model="ruleForm.description"
                  style="min-width: 498px"
                  :rows="5"
                  type="textarea"
                  maxlength="200"
                  resize="none"
                  show-word-limit
                  placeholder="你可以简述门店的推荐商品，也可以向客户描述特色服务，例如包邮和7天无理由退货。（最多200个字）"
              />
            </el-tab-pane>
            <el-tab-pane label="English" name="en">
              <el-input
                  v-model="ruleForm.descriptionEn"
                  style="min-width: 498px"
                  :rows="5"
                  type="textarea"
                  maxlength="600"
                  resize="none"
                  show-word-limit
                  placeholder="You can briefly describe the recommended products of the store, or describe the special services to customers, such as free shipping and 7-day no-reason return. (Up to 600 characters)"
              />
            </el-tab-pane>
          </el-tabs>

        </el-form-item>
        <el-form-item label=" ">
          <div>
            <v-row>
              <v-col>
                <v-btn @click="resetForm">取消</v-btn>
              </v-col>
              <v-col>
                <v-btn color="primary" @click="submit" :disabled="!$handleHasBtnPermission('any', 'store:add', 'store:edit')">保存</v-btn>
              </v-col>
            </v-row>
          </div>
        </el-form-item>
      </el-form>
    </v-container>
  </div>
</template>

<style scoped>

</style>
